import { Footer } from '@/design-system/components/footer/Footer';
import { Container, SxProp, View, Image, SafeAreaView } from 'dripsy';
import React from 'react';

interface PageContainerNativeProps {
  sx?: SxProp;
  noBackgroundImage?: boolean;
}

export const PageContainerNative: React.FC<PageContainerNativeProps> = ({ sx, noBackgroundImage, children }) => {
  return (
    <SafeAreaView>
      <Image
        sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: 100, backgroundColor: '#625f5ce0', zIndex: -1 }}
        source={require('assets/images/headerBackgroundNative.png')}
      />
      <View sx={{ flexGrow: 1 }}>{children}</View>
    </SafeAreaView>
  );
};
